import React from 'react';
import RulesPanel from '../../../../../common/rulesPanel/RulesPanel';
import EmptyState from '../../../../../common/emptyState/EmptyState';
import PromoGroupRow from './PromoGroupRow';
import styles from './styles/freeAdvances.module.scss';

/**
 * The Groups list — reuses the same RulesPanel shell (list + inline "add"
 * link button) General's FreeAdvancesPanel uses, so both sections of the
 * Free Advances sub-tab read as one family. `⊕ Add new group` is
 * RulesPanel's own add button; no separate component needed for it.
 */
function PromoGroupsSection({ groups = [], loading = false, onAddGroup, onOpenMembers, onEditGroup, onDeleteGroup }) {
    return (
        <RulesPanel
            onAdd={onAddGroup}
            addLabel="Add new group"
            classNames={{ root: styles.groupsPanel }}
            emptyState={
                !loading ? (
                    <EmptyState
                        title="No groups yet"
                        description="Add a group to grant specific member_ids a number of fee-free advances."
                    />
                ) : null
            }
        >
            {groups.map((group) => (
                <PromoGroupRow
                    key={group.id}
                    group={group}
                    onOpenMembers={onOpenMembers}
                    onEdit={onEditGroup}
                    onDelete={onDeleteGroup}
                />
            ))}
        </RulesPanel>
    );
}

export default PromoGroupsSection;
